import React, { FC, useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import closeIcon from "../../../../assets/icons/close.svg";
import "./chapterForm.scss";
import ToggleSwitch from "../../ToggleSwitch";
import { Formik, Form, Field } from "formik";
import ButtonComponent from "../../ButtonComponent";
import InputField from "../../InputField";
import { withRouter, RouteComponentProps } from "react-router-dom";
import ChapterService from "../../../../services/CourseServices/ChapterService/chapter.service";
import { serialize } from "serializr";
import { ChapterModel } from "../../../../models/CourseModels/ChapterModel/chapter.model";
import { ExamChaptersService } from "../../../../services/ExamService/ChapterService/chapter.service";

interface ChapterFormProps extends RouteComponentProps {
  title: string;
  visible: boolean;
  setVisible: Function;
  data?: any;
  refreshList: Function;
}

const ChapterForm: FC<ChapterFormProps> = (props) => {
  const { title, visible, setVisible, data, refreshList } = props;

  const formRef = useRef<any>();

  useEffect(() => {
    setInitialValues({
      isActive: data?.isActive ? data.isActive : false,
      name: data?.name || null,
    });
    setUrlParams(props.match?.params);
  }, [data, props]);

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({});
  const [urlParams, setUrlParams] = useState<any>({});

  const handleClose = () => {
    setVisible(false);
    formRef.current.resetForm(initialValues);
  };

  const handleSubmit = (values: any) => {
    setButtonLoading(true);
    if (props.location.pathname.includes("exams") && urlParams?.subjectId) {
      if (!data) {
        ExamChaptersService.createNewExamChapter(
          {
            examSubjectId: parseInt(urlParams.subjectId),
            name: values.name,
            isActive: values.isActive,
          },
          (response: any) => {
            refreshList();
            setVisible(false);
            setButtonLoading(false);
            formRef.current.resetForm(initialValues);
          },
          (error: any) => {
            setButtonLoading(false);
            formRef.current.resetForm(initialValues);
          }
        );
      } else {
        ExamChaptersService.updateExamChapter(
          {
            chapterId: data?.id,
            chapterData: values,
          },
          (response: any) => {
            refreshList();
            setVisible(false);
            setButtonLoading(false);
            formRef.current.resetForm(initialValues);
          },
          (error: any) => {
            setButtonLoading(false);
            formRef.current.resetForm(initialValues);
          }
        );
      }
    } else {
      let chapterData: any = { chaptor: serialize(ChapterModel, values) };
      if (!data) {
        chapterData.chaptor.class_room_subject_id = urlParams?.subjectId;
        ChapterService.createChapter(
          chapterData,
          () => {
            refreshList();
            setVisible(false);
            setButtonLoading(false);
            formRef.current.resetForm(initialValues);
          },
          () => {},
          () => {
            setButtonLoading(false);
            formRef.current.resetForm(initialValues);
          }
        ).then();
      } else {
        ChapterService.updateChapter(
          data?.id,
          chapterData,
          () => {
            refreshList();
            setButtonLoading(false);
            setVisible(false);
          },
          () => {},
          () => {
            setButtonLoading(false);
          }
        ).then();
      }
    }
  };

  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={handleClose}
      footer={null}
      className="board-form__modal"
      closeIcon={<img src={closeIcon} alt="" />}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="board-form__header">
                <div className="board-form__title">{title}</div>
                <div className="board-form__toggle">
                  <Field name="isActive" as="switch">
                    <ToggleSwitch
                      checked={values.isActive}
                      handleChange={() => {
                        setFieldValue("isActive", !values.isActive);
                      }}
                    />
                  </Field>
                </div>
              </div>

              <div className="board-form__input">
                <div className="board-form__label">Chapter Name *</div>
                <InputField type="text" name="name" placeholder="Type here" />
              </div>

              <div className="board-form__action">
                <div
                  className="board-form__button"
                  onClick={() => {
                    handleClose();
                    resetForm({});
                  }}
                >
                  <ButtonComponent buttonContent="Cancel" type="text" />
                </div>
                <div className="board-form__button">
                  <ButtonComponent
                    buttonContent={data ? "Update" : "Create"}
                    type="primary"
                    htmlType="submit"
                    loading={buttonLoading}
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default withRouter(ChapterForm);
